import { useMemo } from 'react'

import { useProjectList } from '../../main'
import { useSelectedProject } from '../../main/hooks/useSelectedProject'
import { ProjectSource } from '../lib/auth.types'

/**
 * Данный массив соответствует таблице доступов к разделам ЛК.
 * Ссылка на документацию:
 * https://wiki.sminex.com/pages/viewpage.action?pageId=138440232
 * ВАЖНО! ПОРЯДОК МЕНЯТЬ НЕЛЬЗЯ
 */
const entities = [
  'finances',
  'survey',
  'counters',
  'cameras',
  'doorphone',
  'feedback',
  'doorkeys',
  'requestsViewAll',
  'contactsRead',
  'contactsWrite',
  'requests',
  'posts'
] as const

export type ApiServices = (typeof entities)[number] | 'acts'

const getPermissionMaskView = (permissionMasks: number[]) => {
  return Math.max(...permissionMasks)
    .toString(2)
    .split('')
    .reverse()
}

export const usePermissions = () => {
  const { data: projects } = useProjectList()

  const { selectedProject } = useSelectedProject()

  return useMemo(() => {
    const permissionMasks = selectedProject?.personalAccounts.map(
      ({ permissionMask }) => permissionMask
    )
    const projectsPermissionsMasks = projects?.map(project =>
      project.personalAccounts.map(personalAccount =>
        getPermissionMaskView([personalAccount.permissionMask])
      )
    )

    const permissionMaskView = getPermissionMaskView(permissionMasks || [0])

    const permissions = {} as Record<ApiServices, boolean>

    entities.forEach((entity, index) => {
      permissions[entity] = Boolean(+permissionMaskView[index])
    })

    permissions.acts =
      permissions.finances && selectedProject?.src === ProjectSource.BU

    permissions.contactsRead =
      projectsPermissionsMasks
        ?.flat(1)
        .some(projectPermission => projectPermission[8] === '1') || false

    permissions.contactsWrite =
      projectsPermissionsMasks
        ?.flat(1)
        .some(projectPermission => projectPermission[9] === '1') || false

    return permissions
  }, [projects, selectedProject?.personalAccounts, selectedProject?.src])
}
